import { CourseType } from ".";

export type UserCourseStatus =
    'Planned' |
    'Completed';

export class UserCourse {    
    constructor(
        public id:string,
        public userId:string,
        public provider:string, 
        public type:CourseType,
        public title:string,
        public description:string,
        public status:UserCourseStatus,
        public courseCompleted:Date,
        public isCustomCourse:boolean
    ){}
}